import { render, staticRenderFns } from "./checkDetail.vue?vue&type=template&id=81613f90&scoped=true"
import script from "./checkDetail.vue?vue&type=script&lang=ts"
export * from "./checkDetail.vue?vue&type=script&lang=ts"
import style0 from "./checkDetail.vue?vue&type=style&index=0&id=81613f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81613f90",
  null
  
)

export default component.exports